import React, { ReactElement } from "react";
import {
  DocumentsIcon,
  EvidenceIcon,
  FormsIcon,
  Intake2Icon,
  LetterIcon,
  OriginalFilePacketIcon,
  RFEIcon
} from "./components/common/Icons";
import { FirmConfiguration } from "./types/firm-configuration.type";

export const URLS = {
  privacy: "https://caseblink.com/privacy-policy",
  serviceAgreement: "https://caseblink.com/service-agreement",
  serviceAgreementEmbed: "https://caseblink.com/embed/service-agreement",
  contactSales: "mailto:support@caseblink.com"
};

const baseSupportedExtensions = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".doc",
  ".docx",
  ".xlsx",
  ".xls",
  ".ppt",
  ".pptx"
];

export const isResearchSrcDownloadEnabled =
  import.meta.env.REACT_APP_ENABLE_RESEARCH_SRC_DOWNLOAD === "true";

export const supportedExtensions = baseSupportedExtensions;

export const supportedExtensionsString = supportedExtensions.join(", ");
export const supportedExtensionsString2 = supportedExtensions
  .slice(0, -1)
  .join(", ");

export const firmConfiguration: Record<string, FirmConfiguration> = {
  "jeffries-law": {
    cssForHeader: { background: "#112757" },
    favicon: "/favicons/jeffries-law.ico",
    practiceName: "Jeffries & Corigliano, LLP",
    domainUrl: "https://www.jeffries-law.com/",
    tabTitle: "Jeffries & Corigliano, LLP"
  },
  fakhouryglobal: {
    cssForHeader: { background: "white" },
    favicon: "/favicons/default.ico",
    practiceName: "employmentimmigration",
    domainUrl: "https://fakhouryglobal.com/",
    tabTitle:
      "Fakhoury Global Immigration - Immigration Law, Process, Strategy, Advice."
  },
  canerofadulreis: {
    cssForHeader: { background: "#244e81" },
    favicon: "/favicons/canerofadul.png",
    practiceName: "Canero Fadul Immigration",
    domainUrl: "https://www.canerofadul.com/",
    tabTitle: "Canero Fadul Reis Law | Miami immigration Lawyers"
  },
  sergiolaw: {
    cssForHeader: { background: "white", height: "70px" },
    favicon: "/favicons/default.ico",
    practiceName: "Sergio Law",
    domainUrl: "https://sergiolaw.com/",
    tabTitle: "Sergio Law - Navigating Immigration for Business Success"
  }

  // localhost: {
  //   css: { background: "#112757" },
  //   favicon: "/favicons/jeffries-law.ico",
  //   practiceName: "Jeffries & Corigliano, LLP",
  //   domainUrl: "https://www.jeffries-law.com/"
  // }
};

// List of all beta features
export const betaFeatures = []; // ["Legal Brief: Custom Templates"];
